import { timelineEvents } from "@/mocks/gossip";
import SectionHead from "./SectionHead";

export default function Timeline() {
  return (
    <section id="timeline" className="scroll-mt-24 bg-background-100/70">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <SectionHead
          kicker="COLLAPSE TIMELINE"
          title="塌房时间线"
          note="把一次次「翻车」的起点、转折与爆发，串成一条可回放的线索"
        />
        <div className="relative">
          <div className="absolute left-2 top-0 h-full w-0.5 bg-foreground-200 md:left-1/2 md:-translate-x-1/2" />
          <div className="space-y-8">
            {timelineEvents.map((e, i) => (
              <div key={e.date} className={"relative flex flex-col gap-4 pl-8 md:w-1/2 md:pl-0 " + (i % 2 === 0 ? "md:pr-10 md:text-right" : "md:ml-auto md:pl-10")}>
                <span className={"absolute left-0 top-1 flex h-4 w-4 items-center justify-center rounded-full ring-4 ring-background-100 md:left-auto " + (i % 2 === 0 ? "md:-right-2" : "md:-left-2")}>
                  <span className="h-2.5 w-2.5 rounded-full bg-accent-500" />
                </span>
                <div className="rounded-lg border border-foreground-200/60 bg-background-50 p-4">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={"inline-flex items-center gap-1 rounded px-2 py-0.5 text-xs font-bold " + (i === timelineEvents.length - 1 ? "bg-primary-500 text-foreground-50" : "bg-secondary-100 text-secondary-900")}>
                      <i className="ri-time-line" /> {e.month}
                    </span>
                    <span className="text-xs text-foreground-500">{e.date}</span>
                  </div>
                  <h3 className="font-heading mt-2 text-lg font-bold text-foreground-950">{e.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{e.desc}</p>
                  <p className="mt-2 inline-flex items-center gap-1 text-xs text-accent-700"><i className="ri-bar-chart-2-line" />{e.votes}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}